import React,{useEffect,useRef} from "react";
import {Link} from "react-router-dom";

export function LinkedRecord({selection,label,path,children}) {
  const ref=useRef(null);
  const id=selection.data?.id;
  useEffect(()=>{if(id){ref.current?.focus({preventScroll:true});ref.current?.scrollIntoView?.({block:"center"});}},[id]);
  if(!selection.present)return null;
  return <section ref={ref} tabIndex={-1} aria-label={`Linkistä avattu ${label}`} className="mb-5 space-y-3 rounded-2xl border border-primary/40 p-3" data-testid="linked-record">
    <div className="flex flex-wrap items-center justify-between gap-2"><h2 className="text-sm font-semibold">Linkistä avattu {label}</h2><Link className="min-h-11 text-sm text-primary" to={path}>Sulje kohde</Link></div>
    {selection.loading && <p role="status">Ladataan valittua kohdetta…</p>}
    {selection.error && <div role="alert"><p>Kohdetta ei voitu avata. Se on voitu poistaa, sen tiedot voivat olla vanhentuneet tai sinulla ei ole siihen oikeutta.</p><button type="button" onClick={selection.refetch} className="min-h-11 text-sm text-primary">Yritä avata uudelleen</button></div>}
    {!selection.loading && !selection.error && selection.data && children}
    <p className="text-xs text-muted-foreground">Kohteen avaaminen vain lukee tiedot. Se ei tallenna muutoksia, hyväksy toimintoa tai lähetä viestiä.</p>
  </section>;
}
